import { Button, CircularProgress } from '@mui/material';
import React, { useRef } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { styled } from '@mui/material/styles';
import UploadIcon from '@mui/icons-material/Upload';
import { read, utils } from 'xlsx';
import useExcelExport, { EXCEL_EXPORT_VARIANTS } from '../../../hooks/useExcelExport';
import { replaceDashes } from '../../../helpers/handleImportUser';

// TODO: implemented but not enabled in the UI
const IS_IMPORT_ENABLED = false;

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const ExportImportUsersButtons = ({ total, setImportedData, setModalContent }) => {
    const fileInputRef = useRef(null);

    const { isLoading, handleExport } = useExcelExport();

    const handleImport = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const workbook = read(event.target.result, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const sheetData = utils.sheet_to_json(sheet);
            const updatedSheetData = sheetData.map((userData) => replaceDashes(userData));
            setImportedData(updatedSheetData);
        };

        reader.readAsBinaryString(file);
    };
    return (
        <>
            <Button
                sx={{ m: 1 }}
                onClick={() => handleExport(total, EXCEL_EXPORT_VARIANTS.USERS)}
                startIcon={isLoading ? <CircularProgress size={20} /> : <DownloadIcon />}
                disabled={isLoading}
            >
                Felhasználók exportálása
            </Button>
            {IS_IMPORT_ENABLED && (
                <Button
                    component="label"
                    startIcon={<UploadIcon />}
                    onClick={() => {
                        setModalContent(null);
                        setImportedData(null);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = null;
                        }
                    }}
                    disabled={isLoading}
                >
                    Import
                    <VisuallyHiddenInput
                        ref={fileInputRef}
                        type="file"
                        onChange={(event) => {
                            handleImport(event);
                        }}
                    />
                </Button>
            )}
        </>
    );
};

export default ExportImportUsersButtons;
